import { useMemo } from 'react';
import { StyledSelect } from '~/components/dropdowns/select.style';

interface HouseholdOccupancySelectComponentProps {
  onChange: (value: string) => void;
  value: number | string;
}

const MAX_HOUSEHOLD_OCCUPANCY_LIMIT = 8;

export const HouseholdOccupancySelectComponent = ({
  onChange,
  value,
}: HouseholdOccupancySelectComponentProps) => {
  const houseOccupancyOptions = useMemo(() => {
    const options: Array<{
      disabled: boolean;
      selected: boolean;
      text: string;
      value: number;
    }> = [];
    for (let i = 1; i <= MAX_HOUSEHOLD_OCCUPANCY_LIMIT; i++) {
      options[i - 1] = {
        disabled: false,
        selected: false,
        text: `${i > 1 ? `${i} Persons` : `${i} Person`}`,
        value: i,
      };
    }
    return options;
  }, []);

  const handleChange = (value: string) => {
    const selectedOption = houseOccupancyOptions.find(option => option.value === Number(value));
    onChange(selectedOption ? String(selectedOption.value) : '');
  };

  return (
    <StyledSelect
      disabled={false}
      id="occupancy-select"
      label="Select your household occupancy"
      marginBottom="20px"
      marginTop="20px"
      required
      loading={false}
      minHeight="auto"
      name="houseOccupancy"
      onChange={handleChange}
      options={houseOccupancyOptions}
      value={value}
      withEmptyPlaceholder={false}
      placeholder="Please select an option"
    />
  );
};
